/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RequestEmailUpdateOtpDTO = {
    channel: RequestEmailUpdateOtpDTO.channel;
    countryCode: RequestEmailUpdateOtpDTO.countryCode;
    newEmail: string;
};

export namespace RequestEmailUpdateOtpDTO {

    export enum channel {
        WEB = 'WEB',
        MOBILE = 'MOBILE',
        POS = 'POS',
    }

    export enum countryCode {
        NG = 'NG',
        GH = 'GH',
    }


}
